import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user.isCompleted) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if (isAuthenticated && !user.isCompleted) return <Navigate to={PATH_AUTH.register} />;

  return <>{children}</>;
}
